export default {
    csManagement: {
        page: {
            title: 'CS 管理中心',
            description: '管理租戶配額、文件總量和 Token 消耗控制',
        },
        quota: {
            searchPlaceholder: '搜尋租戶 ID',
            typePlaceholder: '配額類型',
            search: '搜尋',
            create: '新增配額',
            tenantId: '租戶 ID',
            quotaType: '配額類型',
            typeDocument: '文件總量',
            typeToken: 'Token 消耗總量',
            quotaLimit: '配額上限',
            quotaUsed: '已使用',
            contractPeriod: '合約期',
            contractStart: '合約開始',
            contractEnd: '合約結束',
            status: '狀態',
            statusActive: '生效中',
            statusExpired: '已過期',
            remark: '備註',
            action: '操作',
            edit: '編輯',
            delete: '刪除',
            createTitle: '新增配額',
            editTitle: '編輯配額',
            cancel: '取消',
            confirm: '確認',
            saving: '儲存中...',
            featureConfig: '功能配置',
            featureConfigTitle: '功能權限配置',
            featureDisclosure: '交底書',
            featureDisclosureDesc: '發明交底書撰寫功能',
            featurePatentDraft: '專利申請',
            featurePatentDraftDesc: '專利申請文件撰寫功能',
            featureProsecution: 'OAR答覆',
            featureProsecutionDesc: '審查意見答覆撰寫功能',
            userQuotaTitle: '使用者配額明細',
            userQuotaHint: '公司配額上限：{limit} 次',
            userEmail: '使用者郵箱',
            unlimited: '不限制',
            addUser: '新增使用者',
            addUserPlaceholder: '輸入使用者郵箱',
            reset: '清除',
            tenantName: '公司名稱',
            configuredMembers: '已配置員工',
            noConfiguredMembers: '該公司暫無已配置員工',
            tenantInfoNotFound: '未找到該公司',
            tenantInfoFailed: '查詢失敗，請稍後重試',
            featureList: '功能清單',
            featureAll: '全部',
        },
    },
}
